import React,{Component} from 'react';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import { getJSON } from 'jquery'
import { CircularProgress } from 'material-ui/Progress';
class BlogContext extends Component {
    constructor(){
        super();
        this.state={
            load:false,
            blog:''
        }
    }
    componentWillMount(){
        this.setState({
            load:true
        })
        getJSON('http://123.207.90.121:8080/newBlog/api/getBlog',{id:this.props.id}).then(response=>{
            const data=response.data;

            if (response.code>=1){
                this.setState({
                    blog:data
                })
                console.log("加载blogContext成功"+this.state.data)
            }else {
                console.log("加载blogContext失败")
            }
            this.setState({load:false})

        },error=> {
            this.setState({load:false})
        })

    }

    replaceStr(context){
        var reg = new RegExp( 'pre>' , "g" )
        context= context.replace( reg , 'code>' );
        reg =new RegExp('<img','g');
        context=context.replace( reg , '<p style="text-align: center"><img' );
        reg =new RegExp('</img>','g');
        context=context.replace( reg , '</img></p>' );
        return context;
    }

render(){
    if (this.state.load){
        return (<table valign="medium" align="center" style={{width:'100%',height:'100%'}}>
            <tbody><tr><td align="center"><CircularProgress style={{color:'green'}} />
            </td></tr></tbody></table>)
    }
    return(

        <table style={{width:'100%'}}><tbody><tr>
            <td align="center" valign="medium">
            <h1 style={{fontWeight:'lighter'}}>{this.state.blog.blogTitle}</h1>
        </td></tr>

        <tr>
            <td   valign="medium">
                <Paper style={{wordWrap:'break-word',padding:'30px 40px 30px',marginRight:'10px',background: 'white',
                    wordBreak:'break-all', textIndent:'2em',
                    overflow: 'hidden'  }} dangerouslySetInnerHTML={{
                    __html:this.replaceStr(this.state.blog.blogContext)
                }}>
                </Paper>
            </td>
        </tr></tbody>
        </table>
    )
}
}
export  default BlogContext;


// WEBPACK FOOTER //
// ./src/Compent/page/BlogContext.js